import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from '../../../utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class SbtrService {

  constructor(
    private http: HttpService,
  ) { }

  filter(data?: any) {
    return this.http.post(Path.SUMMARY_BY_TERRITORY_REPORT.FILTER, data);
  }
  
  generate(data?: any) {
    return this.http.post(Path.SUMMARY_BY_TERRITORY_REPORT.GENERATE, data);
  }

  getList(data?: any) {
    return this.http.post(Path.SUMMARY_BY_TERRITORY_REPORT.GET_LIST, data);
  }

}